module.exports = __webpack_public_path__ + "static/media/flower.d7c675d5.svg";